Ext.define('SA.view.sidebar.business.BrowseBusinessCodes', {
    alias: 'widget.browse-business-codes',
    extend: 'SA.view.ArrowMenu',

    autoScroll: false,
    behaveAsWindow: true,
    closeAction: 'hide',
    cls: 'sa-business-code-browser',
    codeType: 'naics',
    height: 660,
    width: 762,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-business-code-browser-header',
            height: 52,

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-business-code-browser-title',
                    html: 'Industry Classification System'
                }, {
                    xtype: 'sa-toggle-switch',
                    cls: 'sa-business-code-browser-toggle-switch',
                    itemId: 'codeType',
                    leftText: 'SIC',
                    rightText: 'NAICS'
                }, {
                    xtype: 'sa-text-field',
                    clearButton: true,
                    cls: 'sa-business-code-browser-filter-text',
                    icon: true,
                    itemId: 'filterText',
                    ui: 'compact'
                }, {
                    xtype: 'close-button',
                    closeAction: 'hide'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-business-code-browser-crumb-ct',
            height: 36,
            itemId: 'breadcrumb',

            tpl: [
                '<span class="sa-business-code-browser-count-heading">Count</span>',
                '<tpl for=".">',
                    '<span class="sa-business-code-browser-crumb',
                    '<tpl if="xindex === xcount">',
                        ' sa-business-code-browser-crumb-disabled',
                    '</tpl>',
                    '" data-sa-code="{code}">',
                    '<tpl if="code">',
                        '<span class="sa-business-code-browser-crumb-code">{code}</span> ',
                    '</tpl>',
                    '{title:htmlEncode}</span>',
                '</tpl>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-business-code-browser-grid',
            flex: 1,
            itemId: 'codeList',

            tpl: [
                '<table class="sa-business-code-browser-table">',
                    '<tbody>',
                        '<tpl for=".">',
                            '<tr class="sa-business-code-browser-row" data-sa-code="{0}">',
                                '<td class="sa-business-code-browser-td-code">{0}</td>',
                                '<td class="sa-business-code-browser-td-name">{1:htmlEncode}</td>',
                                '<td class="sa-business-code-browser-td-count">{2:number("0,000")}</td>',
                            '</tr>',
                        '</tpl>',
                    '</tbody>',
                '</table>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-business-code-browser-footer',
            height: 25
        }
    ],

    layout: {
        align: 'stretch',
        type: 'vbox'
    },

    initComponent() {
        this.callParent();

        this.filterTextField = this.down('#filterText');
        this.codeList = this.down('#codeList');
        this.breadcrumb = this.down('#breadcrumb');
        this.codeTypeToggle = this.down('#codeType');
    },

    beforeShow(){
        this.callParent();

        this.setFilterText('');
        this.setParentCode(null);
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-business-code-browser-row',

            click: (ev, target) => {
                var code = target.getAttribute('data-sa-code');

                if (code.length >= 6) {
                    this.fireEvent('select', this, this.codeType, code);

                    this.hide();
                }
                else {
                    this.setParentCode(code);
                }
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-business-code-browser-row-over');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-business-code-browser-row-over');
            }
        });

        this.breadcrumb.el.on({
            delegate: '.sa-business-code-browser-crumb',

            click: (ev, target) => {
                if (Ext.fly(target).hasCls('sa-business-code-browser-crumb-disabled')) {
                    return;
                }

                this.setParentCode(target.getAttribute('data-sa-code'));
            }
        });

        this.codeTypeToggle.on('change', (toggle, checked) => {
            this.setCodeType(checked ? 'naics' : 'sic');
        });

        this.filterTextField.on('change', field => {
            this.setFilterText(field.getValue());
        }, null, {buffer: 200});
    },

    refresh() {
        var parentCode = this.parentCode,
            filterText = this.filterText || '',
            text = filterText.toLowerCase().trim(),
            isNaics = this.codeType === 'naics',
            country = this.country,
            query = {
                country,
                filterText: text,
                isNaics,
                parentCode
            },
            length = 2,
            Codes = isNaics ? SA.data.NaicsCodes : SA.data.SicCodes,
            codes = Codes.forCountry(country),
            crumbs = [{title: 'Categories', code: ''}],
            code = '',
            truncateCrumbLength = 61,
            totalCrumbLength;

        if (Ext.Object.equals(query, this.lastQuery)) {
            return;
        }

        this.lastQuery = query;

        if (text) {
            length = isNaics ? 6 : 8;

            codes = codes.filter(code => code[0].startsWith(text) || code[1].toLowerCase().includes(text));
        }

        if (parentCode) {
            length = isNaics ? parentCode.length + 2 : parentCode.length * 2;

            codes = codes.filter(code => code[0].startsWith(parentCode));

            while (code.length < parentCode.length) {
                code = parentCode.slice(0, code.length + 2);

                crumbs.push({
                    code,
                    title: Codes.getDescription(code)
                });
            }
        }

        codes = codes.filter(code => code[0].length === length);

        do {
            totalCrumbLength = 0;

            --truncateCrumbLength;

            crumbs.forEach(crumb => {
                crumb.title = Ext.util.Format.ellipsis(crumb.title, truncateCrumbLength);
                totalCrumbLength += crumb.title.length;
            });
        } while (totalCrumbLength > 60);

        Ext.suspendLayouts();

        this.codeList.update(codes);
        this.breadcrumb.update(crumbs);
        this.codeTypeToggle.setChecked(isNaics);
        this.filterTextField.setValue(filterText);
        this.filterTextField.setEmptyText('Search ' + (isNaics ? 'NAICS' : 'SIC') + ' codes');

        Ext.resumeLayouts(true);
    },

    setCodeType(codeType) {
        if (this.codeType === codeType) {
            return;
        }

        this.codeType = codeType;

        this.setParentCode(null);

        this.refresh();
    },

    setCountry(country) {
        if (this.country === country) {
            return;
        }

        this.country = country;

        this.refresh();
    },

    setFilterText(filterText) {
        if (this.filterText === filterText) {
            return;
        }

        this.filterText = filterText;

        this.setParentCode(null);

        this.refresh();
    },

    setParentCode(code) {
        if (this.parentCode === code) {
            return;
        }

        this.parentCode = code;

        this.refresh();
    }
});